export default __webpack_public_path__ + "static/media/nollLogo.d152654e.png";